import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, TextField, Button, Grid, Box, Typography } from '@mui/material';
import { Login as ApiLogin } from '../../../api';
import VerifyCode from '../CreateAccount/VerifyCode';
import Terms from '../Terms';
import { validate } from 'validate.js';
import constraints from '../validate-email-constraints';

const Login = ({ setAuthenticated }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState(false);
  const [verifyStage, setVerifyStage] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async e => {
    const emailAddress = email.toLowerCase().trim()
    e.preventDefault();
    setSubmitError(false);
    const validation = validate({emailAddress}, constraints);

    if (validation)
      setSubmitError(validation.emailAddress)
    else
      ApiLogin(emailAddress, password).then(() => {
        setAuthenticated(true);
      }).catch(e => {
        const error = (e.response && e.response.data && e.response.data.errors) || e.message
        if (error === 'User is not verified')
          setVerifyStage(true);
        else if (error === 'Terms and conditions must be accepted')
          setShowTerms(true);
        else
          setSubmitError(error);
      });
  }


  if (showTerms)
    return (
      <Terms 
        email={email} 
        password={password} 
        setAuthenticated={setAuthenticated} 
      />
    );

  if (verifyStage)
    return (
      <VerifyCode setAuthenticated={setAuthenticated} email={email} password={password} />
    );

  return (
    <Container>
      <Typography component="h1" variant="h4">Login</Typography>
      {submitError ? <Typography component="p" color="error">{submitError}</Typography> : null}
      <form onSubmit={handleSubmit}>
        <TextField sx={{marginTop: 1}} value={email} name="email" fullWidth={true} required={true} label="Email address" id="email" onChange={e => setEmail(e.target.value)} />
        <TextField sx={{marginTop: 1}} value={password} name="password" type="password" fullWidth={true} required={true} label="Password" id="password" autoComplete="false" onChange={e => setPassword(e.target.value)} />
        <Grid container justifyContent="center">
          <Box mt={5} mb={5}>
            <Button variant="contained" color="primary" type="submit">Log in</Button>
          </Box>
        </Grid>
        <Grid container direction="column" alignItems="center">
          <Typography>Don't have an account? <Link to="/create-account" style={{color: "inherit"}}>Sign up!</Link></Typography>
          <Typography><Link to="/forgot-password" style={{color: "inherit"}}>Forgot password?</Link></Typography>
        </Grid>
      </form>
    </Container>
  );
}

export default Login;
